export default __webpack_public_path__ + "static/media/quatorze.b96e4267.jpg";